import type { Session } from 'next-auth'
import type { SiteContextModeEnum } from '@/enums/SiteContextModeEnum'
import type { UnpackedSanityArticle } from '@/lib/queries/sanityQueryStrings'

export function getArticleFromSanityArticles(
  articles: UnpackedSanityArticle[],
  siteContext: SiteContextModeEnum,
  language: string,
  session?: Session | null
): UnpackedSanityArticle | undefined {
  return articles?.find((article) => {
    if (!article.sites || article.sites.length === 0) {
      return false
    }

    return (
      article.sites.find((site) => site.includes(siteContext)) &&
      (session || article.userContext === 'allUsers') &&
      article.language === language
    )
  })
}
